var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    { staticClass: "c-site-header" },
    [
      _c("div", {
        ref: "pageOverlay",
        staticClass: "c-page-overlay",
        on: { click: _vm.pageOverlayClickHandler },
      }),
      _vm._v(" "),
      _vm.isMobile
        ? _c("div", { staticClass: "c-header-mobile" }, [
            _c("div", { staticClass: "c-header-mobile__toolbar" }, [
              _c(
                "button",
                {
                  staticClass: "c-header-mobile__toolbar-toggler",
                  on: { click: _vm.sidebarTogglerClickHandler },
                },
                [_c("i", { staticClass: "far fa-align-justify" })]
              ),
              _vm._v(" "),
              _vm.isProgramPage
                ? _c(
                    "button",
                    {
                      staticClass: "c-header-mobile__toolbar-toggler",
                      on: { click: _vm.toggleProgramMenuBar },
                    },
                    [_c("i", { staticClass: "far fa-align-right" })]
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _vm.showAuthenticatedNavbar
              ? _c("div", { staticClass: "c-header__topbar" }, [
                  _c("div", { staticClass: "c-header__topbar-item" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "click-outside",
                            rawName: "v-click-outside",
                            value: _vm.hideProfileMenu,
                            expression: "hideProfileMenu",
                          },
                        ],
                        staticClass: "u-position-relative",
                        on: { click: _vm.toggleProfileMenu },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "c-header__topbar-user-media u-ml-15 l-flex u-ai-center",
                          },
                          [
                            _c("div", { staticClass: "u-text-right u-mr-10" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "c-header__topbar-user-fullname",
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.fullName) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-header__topbar-user-username u-text-mute",
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.userUsername) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "c-header__topbar-user-img",
                              attrs: {
                                src: _vm.userImage,
                                alt: _vm.userUsername,
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("transition", { attrs: { name: "submenu" } }, [
                          _vm.showProfileMenu
                            ? _c(
                                "ul",
                                {
                                  staticClass:
                                    "c-submenu c-submenu--for-user c-submenu--270 c-submenu--right c-submenu--top-right-arrow",
                                  class: { active: _vm.showProfileMenu },
                                },
                                [
                                  _c("li", { staticClass: "c-submenu__item" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "c-submenu__user-media l-flex u-ai-fs",
                                      },
                                      [
                                        _c("img", {
                                          staticClass:
                                            "c-submenu__user-media-img",
                                          attrs: {
                                            src: _vm.userImage,
                                            alt: _vm.userUsername,
                                            width: "64",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "u-ml-10" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "c-submenu__user-media-fullname u-fw-700 u-text-dark",
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(_vm.fullName) +
                                                  "\n                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "c-submenu__user-media-username u-text-mute",
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(_vm.userUsername) +
                                                  "\n                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "u-mt-10" },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "c-badge" },
                                                [_vm._v("Researcher")]
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("li", { staticClass: "c-submenu__item" }, [
                                    _vm.active && _vm.appOwnerCheck
                                      ? _c(
                                          "a",
                                          {
                                            staticClass: "c-submenu__link",
                                            attrs: { href: "/#/account" },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "far fa-user-alt",
                                            }),
                                            _vm._v("My Profile"),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                  _vm._v(" "),
                                  _c("li", { staticClass: "c-submenu__item" }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "c-submenu__link",
                                        attrs: {
                                          href: "#",
                                          id: "log-out-button",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.logoutClick.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "far fa-sign-out-alt",
                                        }),
                                        _vm._v("Sign Out"),
                                      ]
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ],
                      1
                    ),
                  ]),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.isMobile
        ? _c(
            "div",
            { staticClass: "c-header" },
            [
              _vm._m(1),
              _vm._v(" "),
              _c("Navbar"),
              _vm._v(" "),
              _vm.showAuthenticatedNavbar
                ? _c("div", { staticClass: "c-header__topbar" }, [
                    _c(
                      "div",
                      { staticClass: "c-header__topbar-item" },
                      [
                        _c("NotificationPanel", {
                          directives: [
                            {
                              name: "click-outside",
                              rawName: "v-click-outside",
                              value: _vm.hideNotificationsList,
                              expression: "hideNotificationsList",
                            },
                          ],
                          attrs: {
                            "notifications-list-visible":
                              _vm.notificationsListVisible,
                            "app-owner-check": _vm.appOwnerCheck,
                          },
                          on: { "on-toggle": _vm.toggleNotificationsList },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "c-header__topbar-item" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "click-outside",
                              rawName: "v-click-outside",
                              value: _vm.hideProfileMenu,
                              expression: "hideProfileMenu",
                            },
                          ],
                          staticClass: "u-position-relative",
                          on: { click: _vm.toggleProfileMenu },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "c-header__topbar-user-media u-ml-15 l-flex u-ai-center",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "u-text-right u-mr-10" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "c-header__topbar-user-fullname",
                                    },
                                    [_vm._v(_vm._s(_vm.fullName))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "c-header__topbar-user-username u-text-mute",
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.userUsername) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "c-header__topbar-user-img",
                                attrs: {
                                  src: _vm.userImage,
                                  alt: _vm.userUsername,
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("transition", { attrs: { name: "submenu" } }, [
                            _vm.showProfileMenu
                              ? _c(
                                  "ul",
                                  {
                                    staticClass:
                                      "c-submenu c-submenu--right c-submenu--top-right-arrow c-submenu--for-user",
                                    class: { active: _vm.showProfileMenu },
                                  },
                                  [
                                    _c(
                                      "li",
                                      { staticClass: "c-submenu__item" },
                                      [
                                        _vm.active && _vm.appOwnerCheck
                                          ? _c(
                                              "a",
                                              {
                                                staticClass: "c-submenu__link",
                                                attrs: { href: "/#/account" },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fal fa-user-circle",
                                                }),
                                                _vm._v("My Profile"),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      { staticClass: "c-submenu__item" },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "c-submenu__link",
                                            attrs: {
                                              href: "#",
                                              id: "log-out-button",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return _vm.logoutClick.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fal fa-power-off",
                                            }),
                                            _vm._v("Sign Out"),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ],
                        1
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.showAuthenticatedNavbar
                ? _c("nav", { staticClass: "c-menu c-menu--login" }, [
                    _vm._m(2),
                  ])
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isTransactionsPage
        ? _c("div", { staticClass: "c-subheader" }, [
            _c("nav", { staticClass: "c-menu c-menu--secondary" }, [
              _c("ul", { staticClass: "c-menu__list c-menu__list--inline" }, [
                _c(
                  "li",
                  {
                    staticClass: "c-menu__item",
                    class: {
                      "c-menu__item--active": _vm.isPage("TransactionsPending"),
                    },
                  },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "c-menu__link",
                        attrs: { to: { name: "TransactionsPending" } },
                      },
                      [
                        _c("span", { staticClass: "c-menu__link-text" }, [
                          _vm._v("Pending"),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "c-menu__item",
                    class: {
                      "c-menu__item--active": _vm.isPage(
                        "TransactionsHistorical"
                      ),
                    },
                  },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "c-menu__link",
                        attrs: { to: { name: "TransactionsHistorical" } },
                      },
                      [
                        _c("span", { staticClass: "c-menu__link-text" }, [
                          _vm._v("Historical"),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isMobile ? _c("Navbar") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "c-header-mobile__logo" }, [
      _c(
        "a",
        { staticClass: "c-header-mobile__logo-link", attrs: { href: "/" } },
        [
          _c("img", {
            staticClass: "c-header-mobile__logo-img",
            attrs: {
              src: "/static/images/site-logos/inspectiv-logo.svg",
              alt: "Inspectiv Logo",
            },
          }),
        ]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "c-header-navbar" }, [
      _c("div", { staticClass: "c-navbar__brand" }, [
        _c("div", { staticClass: "c-navbar__brand-logo" }, [
          _c(
            "a",
            { staticClass: "c-navbar__brand-logo-link", attrs: { href: "/" } },
            [
              _c("img", {
                staticClass: "c-navbar__brand-logo-icon",
                attrs: {
                  src: "/static/images/site-logos/inspectiv-logo.svg",
                  alt: "Inspectiv Logo",
                },
              }),
            ]
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "c-menu__list c-menu__list--inline" }, [
      _c("li", { staticClass: "c-menu__item" }, [
        _c("a", { staticClass: "c-menu__link", attrs: { href: "#/log-in" } }, [
          _c("span", { staticClass: "c-menu__link-text" }, [_vm._v("Log in")]),
        ]),
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "c-menu__item" }, [
        _c("a", { staticClass: "c-menu__link", attrs: { href: "#/sign-up" } }, [
          _c("span", { staticClass: "c-menu__link-text" }, [_vm._v("Sign up")]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }